import React from 'react';

import { ISectionWithPagePointersFields } from '../../../types/contentful';

import { PagePointer } from '../PagePointer';
import { BlockContainer, Layout, Column } from '../Layout';
import { Text } from '../Text';

export function SectionWithPagePointers({
  heading,
  pagePointers
}: ISectionWithPagePointersFields) {
  return (
    <BlockContainer
      marginTop={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
      marginBottom={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
      data-blockid="sectionWithCollapsibles"
      data-testid="section-with-page-pointers"
    >
      <Layout>
        <Column size={{ 0: 10, tablet: 8 }} flexDirection="column">
          {heading && (
            <Text
              as="h2"
              fontSize={{
                0: 'h2_0',
                tablet: 'h2_tablet',
                desktop: 'h2_desktop'
              }}
              fontWeight="h2"
              textAlign="center"
              marginBottom={{ 0: 's', tablet: 'm', desktop: 'l' }}
              marginTop={{ 0: 's', tablet: 'm', desktop: 'l' }}
            >
              {heading}
            </Text>
          )}
          {pagePointers &&
            pagePointers.map(({ sys, fields }) => {
              return fields && <PagePointer {...fields} key={sys?.id} />;
            })}
        </Column>
      </Layout>
    </BlockContainer>
  );
}
